import instance, { ADMIN_PREFIX } from 'services/api';
import {
  TreatmentFormDetail,
  TreatmentFormListQuery,
  TreatmentFormListResponse,
  TreatmentFormListRow,
  UpdateTreatmentFormInput
} from 'types/api/treatmentForm';

interface PaginatedEnvelope<T> {
  data: T[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

/**
 * GET /api/v2/admin/treatment-form (cycle-27) — paginated list with
 * `search` filter. PaginatedResponse envelope; service coerces to
 * {results,total} (0-based FE page).
 */
export const fetchTreatmentForms = async (
  query: TreatmentFormListQuery
): Promise<TreatmentFormListResponse> => {
  const params: Record<string, string | number> = {
    page: query.page ?? 1,
    limit: query.limit ?? 10
  };

  if (query.search) params.search = query.search;

  const res = await instance.get<PaginatedEnvelope<TreatmentFormListRow>>(
    `${ADMIN_PREFIX}/treatment-form`,
    { params }
  );

  return {
    results: res.data.data ?? [],
    total: res.data.total ?? 0
  };
};

/**
 * GET /api/v2/admin/treatment-form/:id — detail with files + history.
 */
export const fetchTreatmentFormById = async (
  id: string | number
): Promise<TreatmentFormDetail> => {
  const res = await instance.get<TreatmentFormDetail>(
    `${ADMIN_PREFIX}/treatment-form/${id}`
  );

  return res.data;
};

/**
 * PUT /api/v2/admin/treatment-form/:id — append a history row + flip
 * the status. Returns the hydrated detail.
 */
export const updateTreatmentForm = async (
  id: string | number,
  input: UpdateTreatmentFormInput
): Promise<TreatmentFormDetail> => {
  const res = await instance.put<TreatmentFormDetail>(
    `${ADMIN_PREFIX}/treatment-form/${id}`,
    input
  );

  return res.data;
};
